function formatIsoToPolish(iso, { utc = false } = {}) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return 'Wrong date';

  const pad = (n) => String(n).padStart(2, '0');

  const hours = utc ? d.getUTCHours() : d.getHours();
  const minutes = utc ? d.getUTCMinutes() : d.getMinutes();
  const seconds = utc ? d.getUTCSeconds() : d.getSeconds();
  const day = utc ? d.getUTCDate() : d.getDate();
  const month = (utc ? d.getUTCMonth() : d.getMonth()) + 1;
  const year = utc ? d.getUTCFullYear() : d.getFullYear();

  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)} ${pad(day)}.${pad(month)}.${year}`;
}

export default formatIsoToPolish;